import isEqual from 'lodash/isEqual';
import React, { useEffect } from 'react';

import { usePreviousValue } from '@hero/hooks';
import { ToggleMenu } from '@hero/molecules';

import * as S from './style';

export function ToggleMenuGroup({
  className,
  list,
  defaultActiveMenus,
  multiMenuActive,
  disableNextStepIsActive
}) {
  const defaultActiveMenusPrev = usePreviousValue(defaultActiveMenus);
  const [activeToggleMenusId, setActiveToggleMenus] = React.useState(defaultActiveMenus || []);
  const activeToggleMenuIndex = list.findIndex(({ id }) => activeToggleMenusId.includes(id));

  useEffect(() => {
    if (!isEqual(defaultActiveMenusPrev, defaultActiveMenus)) {
      setActiveToggleMenus(defaultActiveMenus);
    }
  }, [defaultActiveMenus]);

  return (
    <S.ToggleMenuGroup className={className}>
      {list
        ?.filter(item => !item?.isHided)
        .map((item, toggleIndex) => {
          const onClick = id => {
            const itemId = id || item.id;

            const activeToggleMenuId = activeToggleMenusId.find(id => id === itemId);

            if (activeToggleMenuId) {
              if (!disableNextStepIsActive) {
                setActiveToggleMenus(activeToggleMenusId.filter(id => id !== itemId));
              }
            } else {
              setActiveToggleMenus(multiMenuActive ? [...activeToggleMenusId, itemId] : [itemId]);
            }
          };

          return (
            <React.Fragment key={item.id}>
              {item?.TopContent && (
                <S.ToggleMenuGroupHeader as="div" variant="body1Bold" color="fg" emphasis="weaker">
                  {item.TopContent}
                </S.ToggleMenuGroupHeader>
              )}
              <ToggleMenu
                menuId={item.id}
                label={item.label}
                icon={item.icon}
                hasWarningIcon={item.hasWarningIcon}
                title={item.title}
                onClick={onClick}
                hasAccordionIcon={item.hasAccordionIcon}
                isActive={activeToggleMenusId.filter(id => id === item.id).length > 0}
                disabled={
                  disableNextStepIsActive && activeToggleMenuIndex < toggleIndex && !multiMenuActive
                }
              >
                {typeof item.children === 'function'
                  ? item.children({ activeToggleMenusId, onClick })
                  : item.children}
              </ToggleMenu>
              {item?.BottomContent}
            </React.Fragment>
          );
        })}
    </S.ToggleMenuGroup>
  );
}
